import React from 'react'
import ScheduleView from '../../Profile/Schedule/ScheduleView'

export default function CardSchedule({publicSchedule}) {
  return (
    <section className="containerMain">
        <p className="containerMain_title">Horarios de servicio</p>
        <article className="cardMain">
          <ScheduleView smallView={true} optionsButton={false} publicSchedule={publicSchedule} />
        </article>
    </section>
  )
}
